import styled from '@emotion/styled';
import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {EIconButton} from 'webapp-lib/Components';

import {Pause, Play} from '_/assets/images';

export function PlayButton({
  startTimer,
  stopTimer,
  isOngoing,
  disabled = false,
}: {
  startTimer: () => void;
  stopTimer: () => void;
  isOngoing: boolean;
  disabled?: boolean;
}): React.ReactElement {
  const {t} = useTranslation('timetracker');

  const handleClick = useCallback(
    (event: React.MouseEvent, callback: () => void) => {
      event.stopPropagation();
      callback();
    },
    []
  );

  return (
    <StyledPlayButton>
      {!isOngoing && (
        <EIconButton
          disabled={disabled}
          title={
            !disabled
              ? t('components.timer.startTracking.title')
              : t('components.timer.startTracking.titleRequired')
          }
          onClick={(evt) => handleClick(evt, startTimer)}
        >
          <Play />
        </EIconButton>
      )}
      {isOngoing && (
        <EIconButton
          disabled={disabled}
          title={t('components.timer.stopTracking.title')}
          onClick={(evt) => handleClick(evt, stopTimer)}
        >
          <Pause />
        </EIconButton>
      )}
    </StyledPlayButton>
  );
}

const StyledPlayButton = styled.div`
  & .EIconButton {
    padding-left: var(--gutter-medium);
    padding-right: var(--gutter-medium);

    cursor: pointer;

    &:disabled {
      opacity: 0.65;
      cursor: not-allowed;
      pointer-events: all;
    }
  }
`;
